const selectors = {
  mobileBurgerMenuIcon: '[data-ga^="burger-menu-button"]',
  navigationElement:
    '[data-ga^="navigationlink"],[data-ga^="mobileNavigationlink"]',
  socialMediaIcon:
    'a[title="Twitter"], a[title="Facebook"], a[title="Instagram"], a[title="Pinterest"], a[title="YouTube"]',
  searchButtonElement: `[data-ga='destination-selector'],
        [data-ga='autocomplete-clear-search-input'],
        [data-ga='date-selector'],
        [data-ga='party-selector'] [aria-label='party']`,
  accordionTitle: '[data-testid="accordion-item"] >[data-ga="accordion-title"]',
  accordionLink: '[data-testid="accordion-item"] [data-testid="link"]',
}

export default selectors
